export default "__VITE_ASSET__D12XBky3__"